import { render, staticRenderFns } from "./testQuestionUs.vue?vue&type=template&id=79b78b30&scoped=true&"
import script from "./testQuestionUs.vue?vue&type=script&lang=ts&"
export * from "./testQuestionUs.vue?vue&type=script&lang=ts&"
import style0 from "./testQuestionUs.vue?vue&type=style&index=0&id=79b78b30&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79b78b30",
  null
  
)

export default component.exports